import { useEffect, useState } from "react";
import { mapArrayToObject } from "../../../commonFunctions/arrayFunc";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import Button from "../../../components/FormComponents/Button";
import Input from "../../../components/FormComponents/Input";
import MultiRadio from "../../../components/FormComponents/MultiRadio";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import { useAxiosContext } from "../../../context/AxiosContext";
import { useFormContext } from "../../../context/FormContext";
import useZTheme from "../../../hooks/useZTheme";
import BuilderRightSideBar from "../../../Layouts/BuilderRightSideBar";
import { elementConfig } from "../../../utils/Config/DefaultConfig/elementConfig";
import { getToolTipAttributes } from "../../../utils/tooltip";
import DesktopRenderer from "../../ApplicationBlock/DetailsViewRenderer/Desktop/DesktopRenderer";
import DetailsviewElementsBar from "../../ApplicationBlock/DetailsViewRenderer/Desktop/DetailsviewElementsBar";
import PositionScreenWithEdit from "../../FlexibleLayout/PositionScreenWithEdit";
import { getOffset, getPositionedElementConfig } from "../../FlexibleLayout/utils";

const FormStaticData = () => {
  const { selectedForm, formActvityData, setFormActivityData } = useFormContext();
  const { axiosInstance, handleError } = useAxiosContext();
  const [detailsView, setDetailsView] = useState([]);
  const [tableType, setTableType] = useState("statemachine");
  const [isOpen, setIsOpen] = useState(false);
  const [detailviewMap, setDetailviewMap] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  // const [screenLayoutInfo, setScreenLayoutInfo] = useState({
  //   showGrid: true,
  //   showTree: false,
  //   showTemplate: false,
  //   screenMode: "editable",
  //   scaleFactor: 1,
  //   gridSize: 8
  // });
  const [activeDevice, setActiveDevice] = useState("desktop");
  const staticData = formActvityData?.details_view || {};

  const layoutConfig = staticData?.position_config?.[activeDevice]?.config || [];

  useZTheme(activeDevice);

  const fetchDetailviews = async () => {
    try {
      const { data } = await axiosInstance.get(`/detailsview`);
      const mapArray = mapArrayToObject(data.desktop);
      setDetailviewMap(mapArray.result);
      setDetailsView(data);
    } catch (error) {
      handleError(error);
    }
  };

  const updateStaticData = (id, obj) => {
    // setStaticData({ ...staticData, [id]: obj.id });
    setFormActivityData((prevData) => ({
      ...prevData,
      details_view: {
        ...prevData.details_view,
        [id]: obj.id
      }
    }));
  };

  const updateLayoutConfig = (newLayoutConfig) => {
    setFormActivityData((prevFormActivityData) => {
      const currentLayoutConfig = prevFormActivityData.details_view?.position_config?.[activeDevice]?.config || [];

      const updatedLayoutConfig =
        typeof newLayoutConfig === "function" ? newLayoutConfig(currentLayoutConfig) : newLayoutConfig;

      return {
        ...prevFormActivityData,
        details_view: {
          ...prevFormActivityData.details_view,
          position_config: {
            ...prevFormActivityData.details_view?.position_config,
            [activeDevice]: {
              ...prevFormActivityData.details_view?.position_config?.[activeDevice],
              config: updatedLayoutConfig
            }
          }
        }
      };
    });
  };

  // const handleChangeLayoutInfo = (type, value) => {
  //   setScreenLayoutInfo({ ...screenLayoutInfo, [type]: value });
  // };

  const handleChangeMode = (device) => {
    setActiveDevice(device);
  };

  useEffect(() => {
    fetchDetailviews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tableTypeOptions = [
    {
      id: "statemachine",
      name: "State Machine"
    },
    {
      id: "entity",
      name: "Entity"
    },
    {
      id: "rdbms",
      name: "Rdbms"
    }
  ];

  const getDetailviewOptions = (device) => {
    if (!detailsView[device] || detailsView[device].length === 0) return [];
    const filterDetailview = detailsView[device].filter((detailview) => detailview.table_type === tableType);
    return filterDetailview;
  };

  useEffect(() => {
    if (staticData.detailview_id) {
      const selectedDetailview = detailviewMap[staticData.detailview_id];
      setTableType(selectedDetailview?.table_type);
    } else {
      setTableType("statemachine");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailsView]);

  const handleDragStart = (e, name, id, type) => {
    type = type === "empty" ? "field" : type;
    let newConfig = getPositionedElementConfig(type, id);
    if (newConfig.type === "element") {
      if (type === "activitycard" || type === "activity-recordsview" || type === "progress-bar") {
        newConfig.config = {
          type,
          id
        };
      } else {
        newConfig.config = elementConfig[type === "tableview" ? "table" : type];
      }
    }

    const offset = getOffset(e);
    setDraggedItem(newConfig);
    setDragOffset(offset);
  };

  const modeOptions = [
    { name: <MaterialIcon name="screenshot_monitor" className="mode-options-icons" />, id: "desktop" },
    { name: <MaterialIcon name="smartphone" className="mode-options-icons" />, id: "mobile" },
    { name: <MaterialIcon name="tablet" className="mode-options-icons" />, id: "tablet" }
  ];

  // Get screen width based on active device
  const getScreenWidth = () => {
    if (activeDevice === "mobile") return 512;
    if (activeDevice === "tablet") return 640;
    return 768;
  };

  return (
    <div className="detailsView_outer_wrap">
      <div>
        {staticData?.is_positioned_static_data ? (
          <div className="detailsView_outer_body">
            <div className="screen-center-wrapper">
              <div className="page-action-bar-top">
                <div className="builder_form_icons_container position_absolute" style={{ left: "6px", top: "3px" }}>
                  {modeOptions.map((option) => (
                    <div
                      key={option.id}
                      className={`mode-option ${activeDevice === option.id ? "active" : ""}`}
                      onClick={() => {
                        handleChangeMode(option.id);
                      }}
                    >
                      {option.name}
                    </div>
                  ))}
                  <div className="d-flex align-center mode-option">
                    <MaterialIcon
                      name="edit"
                      className="mode-options-icons"
                      onClick={() => setIsOpen(true)}
                      {...getToolTipAttributes("Edit Static Data", "right", false)}
                    />
                  </div>
                </div>
                {/* <div className="position_absolute left_50" style={{ bottom: "100px" }}>
                  <PositionScreenActionBar
                    screenLayoutInfo={screenLayoutInfo}
                    setScreenLayoutInfo={setScreenLayoutInfo}
                    device={activeDevice}
                  />
                </div> */}
              </div>
              <div className="position-screen-center-page">
                <PositionScreenWithEdit
                  layoutConfig={layoutConfig}
                  setLayoutConfig={updateLayoutConfig}
                  dragOffset={dragOffset}
                  setDragOffset={setDragOffset}
                  draggedItem={draggedItem}
                  setDraggedItem={setDraggedItem}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  device={activeDevice}
                  // type={screenLayoutInfo.showTemplate ? "view" : screenLayoutInfo.screenMode}
                  tableType={"statemachine"}
                  tableId={selectedForm.parentData.split("/")[0]}
                  screenWidth={getScreenWidth()}
                  // scaleFactor={screenLayoutInfo.scaleFactor}
                  // showTree={screenLayoutInfo.showTree}
                  // setShowTree={() => setScreenLayoutInfo({ ...screenLayoutInfo, showTree: false })}
                  // gridSize={screenLayoutInfo.gridSize}
                />
                {/* <BuilderModal
                  isOpen={screenLayoutInfo.showTemplate}
                  onClose={() => handleChangeLayoutInfo("showTemplate", false)}
                  modalName="Templates"
                  customStyleClsName="template_modal_fullsize"
                  bodyStyle={{ minHeight: "100vh", overflow: "auto" }}
                >
                  <PositionedTemplateList />
                </BuilderModal> */}
              </div>
            </div>
            <DetailsviewElementsBar handleDragStart={handleDragStart} device={activeDevice} isPositionedScreen={true} />
          </div>
        ) : (
          <div>
            <div className="static_data_top_dropdown">
              <Button
                size="small"
                variant="secondary"
                onClick={() => {
                  setIsOpen(true);
                }}
                style={{ position: "absolute", top: "6px" }}
              >
                Edit Static Data
              </Button>
            </div>
            <DesktopRenderer
              applicationBlockData={{
                data: {
                  elements: formActvityData.details_view?.elements,
                  table_id: selectedForm.parentData.split("/")[0]
                },
                id: ""
              }}
              isForm={true}
            />
          </div>
        )}
      </div>
      <BuilderRightSideBar isOpen={isOpen} onClose={() => setIsOpen(false)} heading={"Static Data"} size="large">
        <div className="flex_column gap_3 p_3">
          <MultiRadio
            keyName="table_type"
            selectedValue={tableType}
            options={tableTypeOptions}
            onChange={(e) => setTableType(e.target.value)}
            label="Table Type"
            containerClassName="w_100"
          />
          <SingleSelectBox
            label="Select Detailview for Desktop"
            selectedData={staticData.detailview_id || ""}
            containerStyle={{ width: "auto" }}
            options={getDetailviewOptions("desktop")}
            onChange={(obj) => updateStaticData("detailview_id", obj)}
            isSearch={true}
          />
          <SingleSelectBox
            label="Select Detailview for Tablet"
            selectedData={staticData.detailview_id_for_tablet || ""}
            containerStyle={{ width: "auto" }}
            options={getDetailviewOptions("tablet")}
            onChange={(obj) => updateStaticData("detailview_id_for_tablet", obj)}
            isSearch={true}
          />
          <SingleSelectBox
            label="Select Detailview for Mobile"
            selectedData={staticData.detailview_id_for_mobile || ""}
            containerStyle={{ width: "auto" }}
            options={getDetailviewOptions("mobile")}
            onChange={(obj) => updateStaticData("detailview_id_for_mobile", obj)}
            isSearch={true}
          />
          <Input
            type="checkbox"
            label={"Is Positioned Static Data"}
            checked={formActvityData?.details_view?.is_positioned_static_data || false}
            onChange={(e) => {
              const isChecked = e.target.checked;
              setFormActivityData((prevData) => ({
                ...prevData,
                details_view: {
                  ...prevData.details_view,
                  is_positioned_static_data: isChecked
                }
              }));
            }}
          />
        </div>
      </BuilderRightSideBar>
    </div>
  );
};

export default FormStaticData;
